import { render, staticRenderFns } from "./documents-list.vue?vue&type=template&id=1abd996a"
import script from "./documents-list.vue?vue&type=script&lang=js"
export * from "./documents-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports